import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
}
export function Accordion({
  title,
  children
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-[#5EEAD4]/20 overflow-hidden shadow-sm" data-id="element-217">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-218">
        <span className="font-medium text-[#4A3B32] text-lg" data-id="element-219">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-220">
          <ChevronDown className="text-[#14B8A6]" data-id="element-221" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-222">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-223">
            <div className="px-6 pb-6 text-[#5D5D5D] leading-relaxed" data-id="element-224">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}